export default __webpack_public_path__ + "static/media/logo.cf2aa7d6.png";